import { render, staticRenderFns } from "./IntegralOrderList.vue?vue&type=template&id=68779a48&scoped=true"
import script from "./IntegralOrderList.vue?vue&type=script&lang=js"
export * from "./IntegralOrderList.vue?vue&type=script&lang=js"
import style0 from "./IntegralOrderList.vue?vue&type=style&index=0&id=68779a48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68779a48",
  null
  
)

export default component.exports